import { gql } from '@apollo/client'

export const GEOGRAPHIC_HIERARCHY_LEAD_CANDIDATE_FRAGMENT = gql`
  fragment GeographicHierarchyLead on GeographicHierarchyLeadCandidate {
    uuid
    id
    email
    firstName
    lastName
    username
    customerUserId
    numDraftsApproved
    numDraftsTotal
    mainRole
    territoryId
  }
`
